import { Injectable } from '@angular/core';
import API from '@aws-amplify/api';

export class APIGatewayInitRequest {
  headers?: any;
  response?: boolean;
  queryStringParameters?: any;
  body?: any;
}

@Injectable({
  providedIn: 'root'
})
export class ApiGatewayService {

  constructor() { }

  async get(api: { apiName: string, path: string }, init: APIGatewayInitRequest) {
    return await API.get(api.apiName, api.path, init);
  }

  async post(api: { apiName: string, path: string }, init: APIGatewayInitRequest) {
    return await API.post(api.apiName, api.path, init);
  }

  async put(api: { apiName: string, path: string }, init: APIGatewayInitRequest) {
    return await API.put(api.apiName, api.path, init);
  }

  async del(api: { apiName: string, path: string }, init: APIGatewayInitRequest) {
    return await API.del(api.apiName, api.path, init);
  }
}
